import { Component, Prop } from "vue-property-decorator";
import Vuetify from "vuetify";
import Vue from "vue";
import { STYLE_CLASSES } from "@/shared/constants/StyleConstants";
import {
  FORM_CONSTANTS,
  FORM_MESSAGES,
  LIST_DATA_EVENTS
} from "@/shared/constants/FormConstants";
import ModalTemplate from "@/shared/components/ModalTemplate/ModalTemplate.vue";
import ObservationModal from "@/shared/components/ObservationModal/ObservationModal.vue";
import { LIST_ITEM_CONSTANTS } from "./constants/ListItemConstants";
import { ListItemData } from "./model/ListItemData";
import { STATE } from "@/shared/constants/GeneralConstants";
import ImgAvatar from "./../ImgAvatar/ImgAvatar.vue";
import { MULTIMEDIA_CONSTANTS } from "@/modules/Multimedia/constants/multimediaConstants";
import { IMG_SOURCE } from "@/shared/components/ChatBot/constants/ChatBotConstants";

Vue.use(Vuetify);
@Component({
  name: "ListItem",
  components: {
    ModalTemplate,
    ObservationModal,
    ImgAvatar
  }
})
export default class ListItem extends Vue {
  @Prop() private listToDisplay!: object;
  @Prop() private title!: string;
  @Prop() private selectedItem!: string;
  @Prop() private descriptions!: Array<string>;
  @Prop() private operations!: string[];
  @Prop() private clickAction!: string;

  mainOperations: string[] = [];
  secondaryOperations: string[] = [];

  booleanMessage = {
    true: "Activo",
    false: "Inactivo"
  };

  ACTIONS = LIST_ITEM_CONSTANTS.ACTIONS;

  ICONS = LIST_ITEM_CONSTANTS.ICONS;

  primaryBtnClass = STYLE_CLASSES.PRIMARY_BTN;
  primaryBtnRoundClass = STYLE_CLASSES.PRIMARY_ROUND_BTN;
  secBtnClass = STYLE_CLASSES.SECONDARY_BTN;
  terBtnClass = STYLE_CLASSES.TERTIARY_BTN;
  cardClass = STYLE_CLASSES.CARD;
  CANCEL_BTN = FORM_CONSTANTS.BUTTON.CANCEL;
  ACCEPT_BTN = FORM_CONSTANTS.BUTTON.ACCEPT;
  modalText = FORM_MESSAGES.DELETE_MODAL.MESSAGE;
  modalTitle = FORM_MESSAGES.DELETE_MODAL.TITLE;
  STATE = STATE;
  CHAT_BOT_IMAGE = IMG_SOURCE;

  emitOperation(oper: string, item: ListItemData) {
    const id = item.id ?? item._key;
    this.$emit(
      LIST_ITEM_CONSTANTS.HANDLER_OPERATION,
      this.changeOperation(item.state, oper),
      id,
      item.state,
      item.name
    );
  }

  get getListToDisplay() {
    return this.listToDisplay;
  }

  get getClickAction() {
    return this.clickAction;
  }

  get getSelectedItem() {
    return this.selectedItem;
  }

  dashboardConversationStatus(item: ListItemData): "working" | "ready" | "" {
    if (this.$route.name !== "Dashboard") return "";

    const dashboardId = item.id || item._key;
    if (!dashboardId) return "";

    const baseConversationKey = this.$route.params.id || "general";
    const dashboardConversation = this.$store.getters[
      "chatassistant/conversation"
    ](`${baseConversationKey}:dashboard:${dashboardId}`);
    const activeConversation = this.$store.getters[
      "chatassistant/conversation"
    ](baseConversationKey);

    if (
      dashboardConversation.loading &&
      dashboardId !== activeConversation.selectedDashboardId
    ) {
      return "working";
    }
    if (dashboardConversation.hasUnreadResult) return "ready";
    return "";
  }

  get getDescriptions() {
    return this.descriptions;
  }

  get operationsLocal() {
    return this.operations.filter(
      filter => filter != LIST_DATA_EVENTS.SAVE_DATA
    );
  }

  mounted() {
    this.mainOperations = this.operationsLocal.slice(
      0,
      LIST_ITEM_CONSTANTS.MAX_CARD_ACTIONS
    );
    this.secondaryOperations = this.operationsLocal.slice(
      LIST_ITEM_CONSTANTS.MAX_CARD_ACTIONS,
      this.operationsLocal.length
    );
  }

  changeOperation(active: string | boolean, operation: string): string {
    if (operation == LIST_DATA_EVENTS.ACTIVE_DESACTIVED_DATA) {
      if (
        active == this.booleanMessage.true ||
        (typeof active == "boolean" && active)
      ) {
        return LIST_DATA_EVENTS.DESACTIVED_DATA;
      } else {
        return LIST_DATA_EVENTS.ACTIVE_DATA;
      }
    }
    return operation;
  }

  buttonAction(item: ListItemData, opetarion: string): string {
    if (
      item.type == MULTIMEDIA_CONSTANTS.AUDIO_FILE &&
      opetarion == LIST_DATA_EVENTS.VIEW_DATA
    ) {
      opetarion = LIST_DATA_EVENTS.LISTEN_AUDIO;
    }
    const action = this.changeOperation(item.state, opetarion);
    return this.ACTIONS[action];
  }

  buttonIcon(item: ListItemData, operation: string): string {
    if (
      item.type == MULTIMEDIA_CONSTANTS.AUDIO_FILE &&
      operation == LIST_DATA_EVENTS.VIEW_DATA
    ) {
      operation = LIST_DATA_EVENTS.LISTEN_AUDIO;
    }
    const icon = this.changeOperation(item.state, operation);
    return this.ICONS[icon];
  }

  groupOperations() {
    return this.mainOperations.includes(LIST_DATA_EVENTS.DUPLICATE_DATA);
  }
}
